import heroImage from '../../assets/hero-image.jpg';
import { Link } from 'react-router-dom';
import { scrollToSection } from '@/services/helpers';

const Hero = () => (
  <div className="container mx-auto flex flex-col md:flex-row items-center max-w-6xl relative px-4 sm:px-6 lg:px-8">
    {/* Logo - first on mobile */}
    <div
      id="hero-logo"
      className="md:w-1/2 right-0 z-1 md:absolute top-0 md:top-6 flex justify-center md:justify-end order-1 md:order-none"
    >
      <img
        src="/images/logo-layers-cropped.svg"
        alt="Praktijk Iselda logo"
        className="w-28 sm:w-36 md:w-64 lg:w-80 mt-6 md:mt-0 h-auto opacity-50"
      />
    </div>

    {/* HERO Image - third on mobile, first on desktop */}
    <div className="w-full md:my-24 md:w-1/2 mb-8 md:mb-0 z-0 order-3 md:order-1">
      <img
        src={heroImage}
        alt="Iselda - EFT therapeut en systeemtherapeut bij Praktijk Iselda"
        className="rounded-xl shadow-2xl w-full h-auto object-cover fade-in md:-rotate-1 md:mr-16 dark:shadow-gray-800"
        loading="lazy"
      />
    </div>

    {/* Tekst + CTA - second and fourth on mobile, second on desktop */}
    <div className="md:w-1/2 md:pl-20 order-2 md:order-2">
      <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-4 sm:mb-6 mt-4 text-gray-900 leading-tight">
        Verbinding ontstaat door het verschil te erkennen - daar toont de liefde zich
      </h1>
      <p className="text-base sm:text-lg md:text-xl lg:text-2xl mb-6 text-gray-700 leading-relaxed">
        Als systeemtherapeut help ik je de onderliggende patronen in je relaties te begrijpen, zodat
        je weer naar elkaar toe kunt bewegen.
      </p>

      {/* CTA - show on mobile as separate element, inline on desktop */}
      <div className="hidden md:block">
        <Link
          to="/#contact"
          onClick={(e) => {
            e.preventDefault(); // Voorkom de standaard actie van de link
            scrollToSection('contact'); // Scroll naar de sectie met id 'contact'
          }}
          className="bg-accent-50 hover:bg-accent-100 text-accent-800 font-bold py-4 px-8 sm:py-3 sm:px-6 rounded-full
            text-lg shadow-md hover:animate-gelatine inline-block min-h-[44px]"
        >
          Maak een afspraak
        </Link>
      </div>
    </div>

    {/* CTA - fourth on mobile, hidden on desktop */}
    <div className="order-4 md:hidden">
      <Link
        to="/#contact"
        onClick={(e) => {
          e.preventDefault(); // Voorkom de standaard actie van de link
          scrollToSection('contact'); // Scroll naar de sectie met id 'contact'
        }}
        className="bg-accent-50 hover:bg-accent-100 text-accent-800 font-bold py-4 px-8 sm:py-3 sm:px-6 rounded-full
          text-lg shadow-md hover:animate-gelatine inline-block min-h-[44px]"
      >
        Maak een afspraak
      </Link>
    </div>
  </div>
);

export default Hero;
